import { Api } from "../config/request";

export default {
  getStateList(queryParams) {
    return Api.get(
      `/locations/state${
        queryParams && queryParams.length > 0 ? `?${queryParams}` : ""
      }`
    );
  },
  getState(payload) {
    const id = payload.id;
    return Api.get(`/locations/state/${id}`);
  },
  updateState(id, payload) {
    return Api.put(`/locations/state/${id}`, payload);
  },
  createState(payload) {
    return Api.post("/locations/state", payload);
  },
};
